import { environment } from 'src/environments/environment'
import { CreateItem, MenuItem } from './menu.model'
import { AccessRights } from '../features/role/user-role/user-role'
import { RolesType } from '../features/role/role'

export const initialMenu: MenuItem[] = [
  {
    translateString: 'general.dashboard',
    link: '/dashboard',
    icon: 'th-large',
    restrictToRoles: environment.moduleConfigs.dashboardModule.visibleForRoles
  },
  {
    translateString: 'bookingModule.bookings',
    link: '/bookings',
    icon: 'calendar-alt',
    restrictToRoles: environment.moduleConfigs.bookingModule.visibleForRoles,
    accessRights: [AccessRights.Bookings_read]
  },
  {
    translateString: 'saleModule.sales',
    link: '/sales',
    icon: 'shopping-cart',
    restrictToRoles: environment.moduleConfigs.saleModule.visibleForRoles,
    accessRights: [AccessRights.Sales_read]
  },
  {
    translateString: 'paymentModule.payments',
    link: '/payments',
    icon: 'shopping-cart',
    restrictToRoles: environment.moduleConfigs.saleModule.visibleForRoles,
    accessRights: [AccessRights.Sales_read]
  },
  {
    translateString: 'reportModule.reports',
    link: '/reports',
    icon: 'flag',
    restrictToRoles: environment.moduleConfigs.reportModule.visibleForRoles,
    accessRights: [AccessRights.Reports_read]
  },
  {
    translateString: 'reportModule.powerBiReports',
    link: '/powerbi-reports',
    icon: 'link',
    restrictToRoles: environment.moduleConfigs.reportModule.visibleForRoles,
    accessRights: [AccessRights.Reports_read]
  },
  {
    translateString: 'productModule.products',
    link: '/products',
    icon: 'cube',
    restrictToRoles: environment.moduleConfigs.productModule.visibleForRoles,
    accessRights: [AccessRights.Products_read]
  },
  {
    translateString: 'productGroupModule.productGroups',
    link: '/product-groups',
    icon: 'cube',
    restrictToRoles: environment.moduleConfigs.productModule.visibleForRoles,
    accessRights: [AccessRights.ProductGroups_read]
  },
  {
    translateString: 'subscriptionModule.subscriptions',
    link: '/subscriptions',
    icon: 'credit-card',
    restrictToRoles:
      environment.moduleConfigs.subscriptionModule.visibleForRoles,
    accessRights: [AccessRights.Subscription_read]
  },
  {
    translateString: 'courseModule.courses',
    link: '/courses',
    icon: 'cube',
    restrictToRoles: environment.moduleConfigs.courseModule.visibleForRoles,
    accessRights: [AccessRights.Course_read]
  },
  {
    translateString: 'general.relations',
    link: '/members',
    icon: 'users',
    restrictToRoles: environment.moduleConfigs.memberModule.visibleForRoles,
    accessRights: [AccessRights.Member_read]
  },
  {
    translateString: 'organizationModule.organizations',
    link: '/organizations',
    icon: 'codesandcube',
    restrictToRoles:
      environment.moduleConfigs.organizationModule.visibleForRoles,
    accessRights: [AccessRights.Organizations_read]
  },
  {
    translateString: 'memberModule.employees',
    link: '/members/employees',
    icon: 'codesandcube',
    restrictToRoles: environment.moduleConfigs?.employeeModule?.visibleForRoles
      ? environment.moduleConfigs?.employeeModule?.visibleForRoles
      : [RolesType.ADMIN],
    accessRights: [AccessRights.Member_read]
  },
  {
    translateString: 'employeeModule.employeeContracts',
    link: '/employee-contracts',
    icon: 'codesandcube',
    restrictToRoles: environment.moduleConfigs?.employeeModule?.visibleForRoles
      ? environment.moduleConfigs?.employeeModule?.visibleForRoles
      : [RolesType.ADMIN],
    accessRights: [AccessRights.Member_read]
  },
  {
    translateString: 'employeeModule.employeeBookings',
    link: '/employee-bookings',
    icon: 'briefcase',
    restrictToRoles: environment.moduleConfigs?.employeeModule?.visibleForRoles
      ? environment.moduleConfigs?.employeeModule?.visibleForRoles
      : [RolesType.ADMIN],
    accessRights: [AccessRights.Member_read]
  },
  {
    translateString: 'visitModule.visits',
    link: '/visits',
    icon: 'address-book',
    restrictToRoles: environment.moduleConfigs?.visitModule?.visibleForRoles
      ? environment.moduleConfigs?.visitModule?.visibleForRoles
      : [RolesType.ADMIN],
    accessRights: [AccessRights.Member_read]
  },
  {
    translateString: 'emailTemplateModule.emailTemplates',
    link: '/email-templates',
    icon: 'envelope-open-text',
    restrictToRoles:
      environment.moduleConfigs.emailTemplateModule.visibleForRoles,
    accessRights: [AccessRights.EmailTemplates_read]
  },
  {
    translateString: 'surveyModule.surveys',
    link: '/surveys',
    icon: 'list-alt',
    restrictToRoles: environment.moduleConfigs.surveyModule.visibleForRoles,
    accessRights: [AccessRights.Surveys_read]
  },
  {
    translateString: 'giftCardModule.giftCards',
    link: '/gift-cards',
    icon: 'gift',
    restrictToRoles: environment.moduleConfigs.giftCardModule.visibleForRoles,
    accessRights: [AccessRights.GiftCard_read]
  },
  {
    translateString: 'fineModule.fines',
    link: '/fine-rules',
    icon: 'exclamation-circle',
    restrictToRoles: environment.moduleConfigs.fineModule.visibleForRoles,
    accessRights: [AccessRights.FineRules_read]
  },
  {
    translateString: 'raffleModule.raffles',
    link: '/raffles',
    icon: 'award',
    restrictToRoles: environment.moduleConfigs.raffleModule.visibleForRoles,
    accessRights: [AccessRights.Raffle_read]
  },
  {
    translateString: 'general.specialEvents',
    link: '/role-permissions',
    icon: 'users',
    restrictToRoles:
      environment.moduleConfigs.rolePermissionsModule.visibleForRoles,
    accessRights: [AccessRights.RolePermissions_read]
  },
  {
    translateString: 'general.globalSettings', // always keep the settings option at the bottom :)
    link: '/configuration-options/overview',
    icon: 'cog',
    restrictToRoles:
      environment.moduleConfigs.configOptionModule.visibleForRoles,
    accessRights: [AccessRights.ConfigurationOptions_read]
  },
  {
    translateString: 'configurationOptionModule.branding',
    link: '/configuration-options/branding',
    icon: 'cog',
    restrictToRoles:
      environment.moduleConfigs.configOptionModule.visibleForRoles,
    accessRights: [AccessRights.ConfigurationOptions_read]
  },
  {
    translateString: 'configurationOptionModule.fieldsAndTags',
    link: '/configuration-options/filter-tags',
    icon: 'cog',
    restrictToRoles:
      environment.moduleConfigs.configOptionModule.visibleForRoles,
    accessRights: [AccessRights.ConfigurationOptions_read]
  },
  {
    translateString: 'general.settings', // always keep the settings option at the bottom :)
    link: '/configuration-options/settings',
    icon: 'cog',
    restrictToRoles:
      environment.moduleConfigs.configOptionModule.visibleForRoles
    //accessRights: [AccessRights.ConfigurationOptions_read]
  },
  {
    translateString: 'general.siteSettings', // always keep the settings option at the bottom :)
    link: '/configuration-options/site-settings',
    icon: 'cog',
    restrictToRoles:
      environment.moduleConfigs.configOptionModule.visibleForRoles
    //accessRights: [AccessRights.ConfigurationOptions_read]
  },
  {
    translateString: 'general.documents', // always keep the settings option at the bottom :)
    link: '/configuration-options/documents',
    icon: 'cog',
    restrictToRoles:
      environment.moduleConfigs.configOptionModule.visibleForRoles
    //accessRights: [AccessRights.ConfigurationOptions_read]
  },
  {
    translateString: 'serieProposalModule.serieProposals',
    link: '/serie-proposals',
    icon: 'list',
    restrictToRoles:
      environment.moduleConfigs.serieProposalModule.visibleForRoles,
    accessRights: [AccessRights.SerieProposal_read]
  },
  {
    translateString: 'rentalModule.rentals',
    link: '/rentals',
    icon: 'users',
    restrictToRoles: environment.moduleConfigs.rentalModule.visibleForRoles,
    accessRights: [AccessRights.Rental_read]
  }
]

export const initialCreateMenu: CreateItem[] = [
  {
    translateString: 'bookingModule.booking',
    link: '/bookings/create',
    icon: 'calendar-alt',
    restrictToRoles:
      environment.moduleConfigs.bookingModule.rolesWithWritePermission,
    accessRights: [AccessRights.Bookings_write]
  },
  {
    translateString: 'saleModule.sale',
    link: '/sales/create',
    icon: 'shopping-cart',
    restrictToRoles:
      environment.moduleConfigs.saleModule.rolesWithWritePermission,
    accessRights: [AccessRights.Sales_write]
  },
  {
    translateString: 'productModule.product',
    link: '/products/create',
    icon: 'cube',
    restrictToRoles:
      environment.moduleConfigs.productModule.rolesWithWritePermission,
    accessRights: [AccessRights.Products_write]
  },
  {
    translateString: 'subscriptionModule.subscription',
    link: '/subscriptions/create',
    icon: 'link',
    restrictToRoles:
      environment.moduleConfigs.subscriptionModule.rolesWithWritePermission,
    accessRights: [AccessRights.Subscription_write]
  },
  {
    translateString: 'courseModule.course',
    link: '/courses/create',
    icon: 'book-open',
    restrictToRoles:
      environment.moduleConfigs.courseModule.rolesWithWritePermission,
    accessRights: [AccessRights.Course_write]
  },
  // {
  //   translateString: 'locationModule.location',
  //   link: '/locations/create',
  //   icon: 'map-marker-alt',
  //   restrictToRoles:
  //     environment.moduleConfigs.locationModule.rolesWithWritePermission,
  //   accessRights: [AccessRights.Locations_write]
  // },

  {
    translateString: 'giftCardModule.giftCard',
    link: '/gift-cards/create',
    icon: 'gift',
    restrictToRoles:
      environment.moduleConfigs.giftCardModule.rolesWithWritePermission,
    accessRights: [AccessRights.GiftCard_write]
  },
  {
    translateString: 'fineModule.fine',
    link: '/fine-rules/create',
    icon: 'exclamation-circle',
    restrictToRoles:
      environment.moduleConfigs.fineModule.rolesWithWritePermission,
    accessRights: [AccessRights.FineRules_write]
  },
  {
    translateString: 'raffleModule.raffle',
    link: '/raffles/create',
    icon: 'award',
    restrictToRoles:
      environment.moduleConfigs.raffleModule.rolesWithWritePermission,
    accessRights: [AccessRights.Raffle_write]
  },
  {
    translateString: 'general.specialEvents',
    link: '/role-permissions/create',
    icon: 'user-tag',
    restrictToRoles:
      environment.moduleConfigs.rolePermissionsModule.rolesWithWritePermission,
    accessRights: [AccessRights.UserRoles_write]
  }
]
